"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const BookingDetailModalSkeleton = () => (react_1.default.createElement(react_1.Fragment, null,
    react_1.default.createElement(material_1.Skeleton, { sx: { fontSize: "24px" }, width: 100 }),
    react_1.default.createElement(material_1.Skeleton, { width: 200, sx: { fontSize: "20px" } }),
    react_1.default.createElement("div", { style: { display: "flex", gap: "15px", margin: "10px 0" } },
        react_1.default.createElement(material_1.Skeleton, { width: 60, height: 50 }),
        react_1.default.createElement(material_1.Skeleton, { width: 60, height: 50 }),
        react_1.default.createElement(material_1.Skeleton, { width: 60, height: 50 })),
    Array.from(Array(3), (_, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
        react_1.default.createElement(material_1.Skeleton, { width: 100, height: 25, style: { marginTop: 10 } }),
        react_1.default.createElement(material_1.Skeleton, { width: 200, height: 35, style: { marginBottom: 10 } })))),
    react_1.default.createElement(material_1.Skeleton, { width: 100, height: 25, style: { marginTop: 10 } }),
    react_1.default.createElement(material_1.Skeleton, { height: 80, width: "100%", style: { position: "absolute", bottom: "-10px", left: 0 } })));
exports.default = BookingDetailModalSkeleton;
